import ImgBanner from "@/assets/image/video-bg.png"
import REDVERSITY from "@/assets/industry-co-led/partners/REDVERSITY.png";
import OurImg from "@/assets/industry-co-led/banner/our-offering.png";
import MsuAdvantagesImg from "@/assets/industry-co-led/banner/MSU-advantages.png"
import addintionImg from '@/assets/industry-co-led/image/little-girl-checking-up-her-sight-ophthalmology-center.png'

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Img1 from "@/assets/industry-co-led/image/infrastructure-1.png";
import Img2 from "@/assets/industry-co-led/image/infrastructure-2.png";

const Img3 = "https://cdn.msu.edu.in/seminar_hall_c0679f338f.webp";
const Img4 = "https://cdn.msu.edu.in/co_learing_space_66a6494608.webp";
const Img5 = "https://cdn.msu.edu.in/classroommain_b39d235f4d.webp";

import OJLImg1 from "@/assets/industry-co-led/image/OJL-1.png";
import OJLImg2 from "@/assets/industry-co-led/image/OJL-2.png";
import OJLImg3 from "@/assets/industry-co-led/image/OJL-3.png";
import OJLImg4 from "@/assets/industry-co-led/image/OJL-4.png";
import OJLImg5 from "@/assets/industry-co-led/image/OJL-5.png";
import OJLImg6 from "@/assets/industry-co-led/image/OJL-6.png";

export const BhmData = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "BBA in Healthcare Management", url: "" }
        ],
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "BBA in Healthcare Management",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: REDVERSITY
        },
        duration: "3 Years Undergraduate Programme",
        description:
            "Learn about Healthcare and Hospital Administration, Biostatistics and Healthcare Data Analysis, Patient Care Services Management and more.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Job-Linked Programmes"
            }
        ],

        buttons: {
            download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: 'https://cdn.msu.edu.in/industry-co-led-images/ChatGPT+Image+Apr+30%2C+2026%2C+09_19_09+PM+(2).webp',
            buttonText: "Watch Programme Video",
            url: "#"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",

        title: "BBA in Healthcare Management",

        description: [
            "The BBA in Healthcare Management prepares students to manage and lead healthcare organisations with confidence and strategic insight. The programme blends core business fundamentals with specialised healthcare knowledge, covering hospital operations, healthcare systems, patient services, and data-driven decision-making.",

            "Students gain practical exposure through industry projects, case-based learning, and internships within real healthcare settings. With a strong focus on operations, communication, and healthcare regulations, learners develop the skills required to efficiently manage hospitals, clinics, and healthcare services while improving patient experience and organisational performance."
        ],

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Job-Linked Programmes"
            }
        ],

        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],

        journeyTitle: "Your 3 Year Journey",

        journey: [
            {
                "phase": "YEAR 1",
                "title": "Foundations in Healthcare, Data, and Management",
                "description": "Accounting and Analysis, Medical Record Science, Hospital Operations and more"
            },
            {
                "phase": "YEAR 2",
                "title": "Advanced Healthcare Management",
                "description": "Strategic Management in Healthcare, Wellness Management and more"
            },
            {
                "phase": "YEAR 3",
                "title": "Healthcare Policy and Public Health Administration",
                "description": "Understand healthcare policies and public health administration across sectors"
            },
            {
                "phase": "GRADUATE",
                "title": "BBA in Healthcare Management",
                "description": "Industry-ready healthcare management professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",

        title: {
            first: "Comprehensive",
            highlight: "Healthcare Management Education"
        },

        description:
            "We offer a UGC-approved, 3 years undergraduate programme, BBA in Healthcare Management. It is an industry-aligned healthcare management degree designed to build strong skills and prepare students for diverse roles.",

        learningBox: {
            title: "Key Areas of Learning",

            points: [
                "Introduction to Healthcare and Hospital Administration",
                "Biostatistics and Healthcare Data Analysis",
                "Healthcare Marketing and Management",
                "Patient Care Services Management",
                "Strategic Management in Healthcare",
                "Healthcare Planning and Infrastructure"
            ]
        },

        image: 'https://cdn.msu.edu.in/industry-co-led-images/Screenshot+2026-04-30+222743.png'
    },

    whyEMT: {
        tag: "WHY HEALTHCARE MANAGEMENT. WHY NOW.",
        title: "Contribute to a system that directly impacts lives",
        description:
            "Our BBA in Healthcare Management aligns with industry trends, offering a comprehensive curriculum that balances theoretical knowledge with practical experience.",

        stats: [
            {
                value: "7.5%",
                text: "Contribution to GDP from healthcare and projected to reach $370+ billion by 2030",
            },
            {
                value: "2.7 million",
                text: "Additional jobs expected to be generated by 2027 from the healthcare industry",
            },
            {
                value: "70,000+",
                text: "Hospitals across India and increasing healthcare infrastructure investments, the demand for healthcare management professionals continues to rise",
            },
        ],
    },
    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Redversity, Delivered at MSU Campus",
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",

        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
            },
            {
                number: "03",
                text: "In-house state-of-the-art labs, classrooms, co-learning spaces, conference halls and more",
            },
        ],
        pointerTitle: "Highlights from The Programme:",

        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid on-the-job learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned healthcare management professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to ‘learn and earn’ through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives",
        ],

        image: 'https://cdn.msu.edu.in/industry-co-led-images/Screenshot+2026-04-30+222642.png',
    },
    CTA: {
        title: "Start Your Journey in Healthcare Management with Redversity’s",
        highlights: "BBA in Healthcare Management",
        url: "#",
        btnName: "Apply Now"
    },
    onJobtrainningData: {
        tag: "Hands-On Experience",
        title: "On-the-Job Learning",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            { "id": 1, "src": OJLImg1, "alt": "Medical training" },
            { "id": 2, "src": OJLImg2, "alt": "Lab practice" },
            { "id": 3, "src": OJLImg3, "alt": "Patient training" },
            { "id": 4, "src": OJLImg4, "alt": "Lab testing" },
            { "id": 5, "src": OJLImg5, "alt": "Computer lab work" },
            { "id": 6, "src": OJLImg6, "alt": "Chemical lab testing" }
        ]
    },
    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "Bonus Credentials",
                "title": "Additional Skills Certifications",
                "description": "At Medhavi Skills University, students pursuing BBA in Healthcare Management gain opportunities for industry-recognised Skill Certifications from NISM, Great Learning Academy, Simplilearn, HubSpot Academy, Alison Academy, Keka Academy, FinX, LinkedIn Learning, Coursera and more. These certifications, earned alongside the healthcare management degree, enhance industry relevance and prepare students for both employment and entrepreneurship.",
                "image": {
                    "url": 'https://cdn.msu.edu.in/industry-co-led-images/Screenshot+2026-04-30+222845.png',
                    "alternativeText": "Skill Certification"
                },
                "items": [
                    {
                        "id": 1,
                        "text": "Industry-Recognised Certifications",
                        "icon": Icon1
                    },
                    {
                        "id": 2,
                        "text": "Nationally & Globally Recognised",
                        "icon": Icon2
                    }
                ],
                "button": {
                    "text": "Apply Now",
                    "link": "/apply"
                }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description:
            "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms, and industry-relevant facilities",

        images: [
            { id: 1, src: Img1, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 2, src: Img2, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 3, src: Img3, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 4, src: Img4, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 5, src: Img5, size: "small", alt: "Do-Experience-Learn-lab" },
        ],
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
        students: [

            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Eligibility",
        description:
            "10+2 (Any Stream) from a recognised board",
        button: {
            text: 'Apply Now',
            url: ""
        },
        items: [
            {
                title: "10+2 (Any Stream)",
                text: "Students from any stream — Science, Commerce, or Arts — who have completed 10+2 from a recognised board are eligible to apply.",
            },
        ],
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "Join this BBA in Healthcare Management programme and embark on a rewarding journey in healthcare management industry",
        "roles": [
            "Hospital Administrator",
            "Healthcare Operations Executive",
            "Medical Records Manager",
            "Healthcare Analyst",
            "Patient Relationship Manager",
            "Insurance Coordinator",
            "Hospital Marketing Executive",
            "Healthcare HR Executive",
            "Quality & Compliance Executive (Healthcare)",
            "Public Health Program Coordinator",
            "Clinic / Facility Manager",
            "Healthcare Consultant (Entry-level)",
            "Health Insurance Claims Manager",
            "Medical Office Manager",
            "Healthcare Startup Operations Executive"
        ]
    },

    curriculumStructure: {
        "label": "What You Will Learn",
        "heading": "Curriculum Structure",
        "description": "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness, and broad career opportunities across disciplines.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Building the Foundation",
                "description": "This semester introduces students to the core principles of management, communication, and basic healthcare knowledge. Learners develop an understanding of human biology, hospital administration, and essential professional skills. The focus is on creating a strong academic base while building discipline, confidence, and clarity in communication.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Management and Organisational Behaviour", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "English and Professional Communication", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Business Economics", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Introduction to Healthcare and Hospital Administration", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Human Biology and Medical Terminology (C+P)", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Environmental Studies", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Personal Effectiveness", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Holistic Development Module 1 (Curricular, Personality Dev, Hospital/Ambulance Visit I, Live Project I, Portfolio)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Understand core management and organisational behaviour principles",
                    "Communicate professionally in healthcare settings",
                    "Grasp foundational business economics concepts",
                    "Gain an overview of hospital and healthcare administration",
                    "Build medical terminology and human biology knowledge"
                ]
            },
            {
                "name": "Semester 2",
                "title": "Strengthening Healthcare Management & Practical Skills",
                "description": "In this semester, students will develop knowledge of medical record management, healthcare financing, wellness strategies, and the application of technology in healthcare systems. They will also strengthen their communication, interpersonal, and professional skills while gaining practical exposure through simulation labs, ambulance ride-along experiences, live projects, and portfolio development for real-world healthcare environments.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Medical Record Science (C+P)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Health and Wellness Management", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Health Economics and Healthcare Financing", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Information Technology in Healthcare (Applied)", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Business Communication", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Interpersonal Effectiveness", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Healthcare Systems Simulation Lab", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Holistic Development Module 2 (Curricular, Personality Dev, Ambulance Ride-along II, Live Project II, Portfolio)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Manage and interpret medical records",
                    "Understand health economics and financing models",
                    "Apply wellness strategies in healthcare settings",
                    "Use IT tools effectively in healthcare environments",
                    "Develop interpersonal and professional communication skills"
                ]
            },
            {
                "name": "Semester 3",
                "title": "Understanding Healthcare Operations & Systems",
                "description": "This semester focuses on how healthcare organisations function on a day-to-day level. Students explore hospital operations, healthcare marketing, public relations, and health information systems, while also learning about medical ethics and legal frameworks governing the industry.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Hospital Operations Management (C+P)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Healthcare Marketing Management", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Hospital Public Relations & Communication", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Epidemiology and Health Information Systems (C+P)", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Medical Ethics and Healthcare Laws", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Indian Culture and Mindfulness", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Career Readiness", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Holistic Development Module 3 (Curricular, Personality Dev, Industry Visits, Live Project III, Portfolio)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Manage day-to-day hospital operations effectively",
                    "Apply healthcare marketing strategies",
                    "Handle hospital communications and public relations",
                    "Use epidemiological data in health systems",
                    "Navigate medical ethics and legal compliance"
                ]
            },
            {
                "name": "Semester 4",
                "title": "Managing People, Quality & Patient Care",
                "description": "Learners gain insights into managing healthcare teams, ensuring quality standards, and improving patient care services. The curriculum emphasises human resource management, safety protocols, infrastructure planning, and communication skills required in clinical and administrative settings.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Quality Management in Healthcare (C+P)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Human Resource Management in Healthcare", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Occupational Health and Safety (C+P)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Patient Care Services Management (C+P)", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Financial Accounting and Analysis", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Clinical Communication", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Holistic Development Module 4 (Curricular, Personality Dev, Ambulance Ride-along IV, Live Project IV, Portfolio)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Implement quality management systems in healthcare",
                    "Lead and manage healthcare HR functions",
                    "Ensure occupational health and workplace safety",
                    "Improve patient care services and experience",
                    "Plan healthcare infrastructure and facilities"
                ]
            },
            {
                "name": "Semester 5",
                "title": "Specialised Healthcare Management",
                "description": "This semester develops strategic decision-making skills in healthcare. Students learn about policy, public health administration, and drug management while exploring specialised areas like pharmacy management, nutrition, and entrepreneurship within the healthcare ecosystem.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Healthcare Policy and Public Health Administration", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Strategic Management in Healthcare (C+P)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Drug Management and Pharmacy Services", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Biostatistics and Healthcare Data Analysis (C+P)", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Entrepreneurship in Healthcare", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Healthcare Planning and Infrastructure", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Elective: Emergency Department Management / Healthcare Informatics", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Understand healthcare policy and public health systems",
                    "Develop and implement healthcare strategies",
                    "Oversee pharmacy and drug management services",
                    "Apply biostatistics in healthcare data analysis",
                    "Explore entrepreneurship opportunities in healthcare"
                ]
            },
            {
                "name": "Semester 6",
                "title": "Industry Immersion & Professional Application",
                "description": "The final semester is focused on real-world experience through internships, live projects, and research work. Students apply their knowledge in professional healthcare environments, gaining practical exposure and industry insights that prepare them for management roles from day one.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Healthcare Management Internship (at Red.Health Network)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Industry-Based Project Work & Capstone Dissertation", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "HDSIM 6 – Internship Intensive (CV Launch, Live Project Viva, Career Readiness, Portfolio)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            },
            {
                "name": "Value Addition",
                "title": "Value-Added Learning Opportunities",
                "description": "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",

                "subjects": [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }

        ]
    },

    faq: {
        id: 101,
        title: "BBA in Healthcare Management",
        FAQ: [
            {
                "id": 1,
                "Question": "What is the duration of the BBA in Healthcare Management programme?",
                "Answer": "The programme is typically a 3-year undergraduate course divided into 6 semesters, covering both business fundamentals and specialized healthcare subjects."
            },
            {
                "id": 2,
                "Question": "What career opportunities are available after this programme?",
                "Answer": "Graduates can work as Hospital Administrators, Healthcare Operations Executives, Medical Records Managers, Healthcare Analysts, or Insurance Coordinators across hospitals, healthcare startups, and public health organizations."
            },
            {
                "id": 3,
                "Question": "Does the programme include practical training or internships?",
                "Answer": "Yes, the programme includes industry internships, live projects, and a capstone project, ensuring hands-on experience in real healthcare settings."
            },
            {
                "id": 4,
                "Question": "What is the role of Redversity in this programme?",
                "Answer": "Redversity plays a key role in delivering industry-integrated learning, providing students with access to real-world healthcare environments, expert-led training, and hands-on experience."
            },
            {
                "id": 5,
                "Question": "Is a science background required to pursue this course?",
                "Answer": "No, students from any stream (Science, Commerce, or Arts) can apply. The programme starts with foundational subjects to build healthcare understanding."
            },
            {
                "id": 6,
                "Question": "What skills will I gain from this programme?",
                "Answer": "You will develop skills in healthcare operations, data analysis, communication, management, and strategic decision-making, preparing you for both administrative and leadership roles in healthcare."
            },
            {
                "id": 7,
                "Question": "Is this course UGC recognised?",
                "Answer": "Yes."
            },
            {
                "id": 8,
                "Question": "Can you enroll in this degree with a scholarship?",
                "Answer": "Yes. MSU is the only university in Sikkim to ensure 100% of student applicants receive government scholarships. Talk to our counselors to know more."
            },
            {
                "id": 9,
                "Question": "What is the admission procedure?",
                "Answer": "Call +91 98748 75876 for a detailed admission procedure. You can also refer to the link https://www.msu.edu.in/admission-process"
            }
        ]
    },
    coursePrice: { price: "₹5,25,000" }




};